// import css from "./info.module.css";
// import srvd from "../../img/aboutPic.png";
// import { useEffect, useState } from "react";
// import { db } from "../../firebase";
// import { doc, getDoc } from "firebase/firestore";
// export default function AboutAuth() {
//   const [content, setContent] = useState({});

//   useEffect(() => {
//     const fetchContent = async () => {
//       const docRef = doc(db, "aboutAuthContent", "mainPageTexts");
//       const docSnap = await getDoc(docRef);
//       if (docSnap.exists()) setContent(docSnap.data());
//     };

//     fetchContent();
//   }, []);
//   return (
//     <div className={css.aboutWrapAll}>
//       <div className={css.smallWrapAbout}>
//         <div className={css.wrapTwoButton}>
//           <a className={css.aboutCompanyH1One} href="#section1">
//             Авторам текстів
//           </a>{" "}
//           <a className={css.aboutCompanyH1One} href="#section2">
//             Художникам
//           </a>
//         </div>
//         <div className={css.wpaPicAbout}></div>
//         <div id="section1" className={css.autorsNewLabel}>
//           Авторам текстів
//         </div>
//         <div
//           className={css.paragInWrapBig}
//           dangerouslySetInnerHTML={{ __html: content.section1_intro }}
//         ></div>
//         <p className={css.zagalP}>Загальне звернення до Автора.</p>
//         <p className={css.zagalNotNeed}>
//           (Необов’язкове до прочитання. Виключно для допитливих. Всіх інших
//           просимо не заморочуватись. Ми не школа і не партія — нікого не вчимо й
//           нікому нічого не доводимо.)
//         </p>
//         <div
//           className={css.zagalNotNeedDesc}
//           dangerouslySetInnerHTML={{ __html: content.section1_general }}
//         ></div>
//         <p className={css.dogovirPd}>
//           Публічна оферта щодо розгляду Творів Автора рукописів
//         </p>
//         <div className={css.wrapTwoOffer}>
//           <div
//             className={css.firstDogovir}
//             dangerouslySetInnerHTML={{ __html: content.section1_desc }}
//           ></div>{" "}
//           <div
//             className={css.secondDogovir}
//             dangerouslySetInnerHTML={{ __html: content.section1_offer }}
//           ></div>
//         </div>
//         <p className={css.redPIn}>
//           Просимо поваги до нашої роботи наступним чином:
//         </p>
//         <div
//           className={css.opuswork}
//           dangerouslySetInnerHTML={{ __html: content.section2_intronew }}
//         ></div>
//         <div id="section2" className={css.hudognukNewLabel}>
//           Художникам
//         </div>
//         <div
//           className={css.paragInWrapBig}
//           dangerouslySetInnerHTML={{ __html: content.section2_intro }}
//         ></div>
//         <div
//           className={css.postIn}
//           dangerouslySetInnerHTML={{ __html: content.section2_post }}
//         ></div>
//         <div
//           className={css.paragInWrapBig}
//           dangerouslySetInnerHTML={{ __html: content.section2_general }}
//         ></div>
//         <p className={css.zagalP}>Загальне звернення до Художників.</p>
//         <p className={css.zagalNotNeed}>
//           (Необов’язкове до прочитання. Виключно для допитливих. Всіх інших
//           просимо не заморочуватись. Ми не школа і не партія — нікого не вчимо й
//           нікому нічого не доводимо.)
//         </p>
//         <div
//           className={css.zagalNotNeedDesc}
//           dangerouslySetInnerHTML={{ __html: content.section2_desc }}
//         ></div>
//       </div>
//     </div>
//   );
// }
// src/components/about/AboutAuth.jsx
// src/components/about/AboutAuth.jsx
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import css from "./info.module.css";

// Щоб коректно відображались класи, які додає ReactQuill (ql-*)
import "react-quill/dist/quill.core.css";

// Універсальний вивід Quill-HTML з потрібними класами
function QuillView({ html = "", className = "" }) {
  return (
    <div
      className={`${className} ql-editor`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default function AboutAuth() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const ref = doc(db, "aboutAuthContent", "mainPageTexts");
        const snap = await getDoc(ref);
        if (mounted && snap.exists()) setContent(snap.data());
      } catch (e) {
        // за потреби: логування
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className={css.aboutWrapAll}>
      <div className={css.smallWrapAbout}>
        {/* Якірна навігація */}
        <div className={css.wrapTwoButton}>
          <a className={css.aboutCompanyH1One} href="#section1">
            Для авторів
          </a>
          <a className={css.aboutCompanyH1One} href="#section2">
            Для художників
          </a>
        </div>

        {/* Банер/зображення (залишено як було) */}
        <div className={css.wpaPicAbout} />

        {/* ===== Блок 1: Авторам текстів ===== */}
        <div id="section1" className={css.autorsNewLabel}>
          Для авторів
        </div>

        <QuillView
          className={css.paragInWrapBig}
          html={content?.section1_intro}
        />

        <p className={css.zagalP}>Загальне звернення до Автора.</p>
        <p className={css.zagalNotNeed}>
          (Необов’язкове до прочитання. Виключно для допитливих. Всіх інших
          просимо не заморочуватись. Ми не школа і не партія — нікого не вчимо й
          нікому нічого не доводимо.)
        </p>

        <QuillView
          className={css.zagalNotNeedDesc}
          html={content?.section1_general}
        />

        <p className={css.dogovirPd}>
          Публічна оферта щодо розгляду Творів Автора рукописів
        </p>

        <div className={css.wrapTwoOffer}>
          <QuillView
            className={css.firstDogovir}
            html={content?.section1_desc}
          />
          <QuillView
            className={css.secondDogovir}
            html={content?.section1_offer}
          />
        </div>

        <p className={css.redPIn}>
          Просимо поваги до нашої роботи наступним чином:
        </p>

        <QuillView className={css.opuswork} html={content?.section2_intronew} />

        {/* ===== Блок 2: Художникам ===== */}
        <div id="section2" className={css.hudognukNewLabel}>
          Для художників
        </div>

        <QuillView
          className={css.paragInWrapBig}
          html={content?.section2_intro}
        />

        <QuillView className={css.postIn} html={content?.section2_post} />

        <QuillView
          className={css.paragInWrapBig}
          html={content?.section2_general}
        />

        <p className={css.zagalP}>Загальне звернення до Художників.</p>
        <p className={css.zagalNotNeed}>
          (Необов’язкове до прочитання. Виключно для допитливих. Всіх інших
          просимо не заморочуватись. Ми не школа і не партія — нікого не вчимо й
          нікому нічого не доводимо.)
        </p>

        <QuillView
          className={css.zagalNotNeedDesc}
          html={content?.section2_desc}
        />
      </div>
    </div>
  );
}
